import { put, takeEvery, call } from "redux-saga/effects"
import { authRequest } from "engine/modules/authRequest"
import env from "src/env"
import { DELETE_EVENT_RESOURCE } from "../actions/types"
import {
  deleteEventResourceSuccess,
  deleteEventResourceError,
  readEventAvailableResourcesList,
} from "../actions/creators"

const { REACT_APP_API_URL } = env

// delete resource from event
function* requestMarkAll(action) {
  const {
    config: { eventUuid, resourceUuid, availableQuery },
  } = action
  try {
    const response = yield call(authRequest, {
      url: `${REACT_APP_API_URL}/events/${eventUuid}/resources`,
      method: `delete`,
      data: [resourceUuid],
    })

    yield put(deleteEventResourceSuccess(action, response))
    yield put(
      readEventAvailableResourcesList({
        uuid: eventUuid,
        availableQuery,
      }),
    )
  } catch (error) {
    yield put(deleteEventResourceError(action, error))
  }
}

export default function* readSaga() {
  yield takeEvery(DELETE_EVENT_RESOURCE, requestMarkAll)
}
